import React, { useEffect, useState } from "react";
import {
  Button,
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
} from "reactstrap";
import classnames from "classnames";

//images
import imagePlaceholder from "../../../assets/images/users/user-dummy-img.jpg";

// constants
import { STATUS_TYPES } from "../../../constants";
import SearchCustomerModal from "components/SearchCustomerModal";
import { stubFalse } from "lodash";
import { useRedux } from "hooks";
import { createSelector } from "reselect";
import { UserTypes } from "api";
import TextBox from "components/TextBox";
import { APIClient } from "api/apiCore";
import * as url from "../../../api/urls";
import SearchCustomerModalV2 from "components/SearchCustomerModalV2";
interface ProfileUserProps {
  onCloseUserDetails: () => any;
  chatUserDetails: any;
  onOpenVideo: () => void;
  onOpenAudio: () => void;
}
const ProfileUser = ({
  onCloseUserDetails,
  chatUserDetails,
  onOpenAudio,
  onOpenVideo,
}: ProfileUserProps) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen(!dropdownOpen);

  const { dispatch, useAppSelector } = useRedux();
  const errorData = createSelector(
    (state: any) => state.Profile2,
    (profile2) => ({
      userType: profile2.userType,
      isAdmin: profile2.isAdmin
    })
  );
  const { userType, isAdmin } = useAppSelector(errorData);

  const isObserver = chatUserDetails.memberId ? false : true;
  const canMapGroup = userType == UserTypes.Employee || (userType == UserTypes.Employee && isAdmin);
  //const canMapGroup = (!isObserver && userType == UserTypes.Employee) || (userType == UserTypes.Employee && isAdmin);

  const profile = chatUserDetails.profileImage
    ? chatUserDetails.profileImage
    : imagePlaceholder;

  const fnGetFullName = () => {
    if (chatUserDetails.displayName) return chatUserDetails.displayName;
    return chatUserDetails.name === undefined
      ? chatUserDetails.firstName
        ? `${chatUserDetails.firstName} ${chatUserDetails.lastName}`
        : "-"
      : chatUserDetails.name;
  }




  const fullName = fnGetFullName();
  // chatUserDetails.name === undefined
  //   ? chatUserDetails.firstName
  //     ? `${chatUserDetails.firstName} ${chatUserDetails.lastName}`
  //     : "-"
  //   : chatUserDetails.name;

  // console.log('chatUserDetails:', chatUserDetails);

  const [isModalFindCustomerOpen, setIsModalFindCustomerOpen] = useState<boolean>(false);
  const onModalFindCustomerClose = () => {
    if (canMapGroup) {
      setIsModalFindCustomerOpen((prev) => !prev);
    }
  }

  const onModalFindCustomer = async () => {
    console.log('chatUserDetails:', chatUserDetails);
    if (chatUserDetails.contactType === UserTypes.Group) {
      if (canMapGroup) {
        setIsModalFindCustomerOpen((prev) => !prev);
      }
    } else if (chatUserDetails.contactType === UserTypes.GroupSupplier) {
      if (canMapGroup) {
        setIsModalFindCustomerOpen((prev) => !prev);
      }
    } else {
      alert('Not yet support for ' + chatUserDetails.contactType);
    }
  }

  const [editingName, setEditingName] = useState<boolean>(false);
  const [nameEdit, setNameEdit] = useState<any>(fullName);
  const onEditNameClick = async () => {
    try {
      setNameEdit(fullName);
      setEditingName(true);
    } catch (e) {
      console.error(e);
      alert((e as any).message);
    }
  }
  const onSaveNameClick = async () => {
    try {
      if (!nameEdit) {
        alert('กรุณาระบุชื่อ');
        return;
      }
      if ((nameEdit as string).toLowerCase() == (fullName as string).toLowerCase()) {
        setEditingName(false);
        return;
      } else {

        const api = new APIClient();
        const parm = {
          groupId: chatUserDetails.userGroupId,
          groupFullName: nameEdit
        };
        api.fnPostForm(url.CHANGE_GROUP_FULL_NAME, parm)
          .then((result) => {
            setEditingName(false);
          })
          .catch((error) => {
            console.error(error);
            alert((error as any).message);
          });
      }
      // console.log(nameEdit);
    } catch (e) {
      console.error(e);
      alert((e as any).message);
    }
  }
  const onCancelNameClick = async () => {
    try {
      setNameEdit(fullName);
      setEditingName(false);
    } catch (e) {
      console.error(e);
      alert((e as any).message);
    }
  }


  // useEffect(()=>{
  //   console.log('ProfileUser.chatUserDetails:', chatUserDetails);
  // },[chatUserDetails]);

  return (
    <div className="p-3 border-bottom">
      {/* <SearchCustomerModal isOpen={isModalFindCustomerOpen} onClose={onModalFindCustomerClose} groupId={chatUserDetails.id} groupName={fullName} /> */}
      <SearchCustomerModalV2 isOpen={isModalFindCustomerOpen} onClose={onModalFindCustomerClose} groupId={chatUserDetails.id} groupName={fullName} groupType={chatUserDetails.contactType} />
      <div className="user-profile-img">
        <img src={profile} className="profile-img rounded" alt="" />
        <div className="overlay-content rounded">
          <div className="user-chat-nav p-2">
            <div className="d-flex w-100">
              <div className="flex-grow-1">
                <Button
                  color="none"
                  type="button"
                  className="btn nav-btn text-white user-profile-show d-none d-md-block"
                  onClick={onCloseUserDetails}
                >
                  <i className="bx bx-x"></i>
                </Button>
                <Button
                  type="button"
                  color="none"
                  className="btn nav-btn text-white user-profile-show d-block d-md-none"
                  onClick={onCloseUserDetails}
                >
                  <i className="bx bx-left-arrow-alt"></i>
                </Button>
              </div>
              <div className="flex-shrink-0">
                {/* 
                #define PENDING_ADD_MENU
                <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                  <DropdownToggle
                    color="none"
                    className="btn nav-btn text-white"
                    type="button"
                  >
                    <i className="bx bx-dots-vertical-rounded"></i>
                  </DropdownToggle>
                  <DropdownMenu className="dropdown-menu-end">
                    <DropdownItem
                      className="d-flex justify-content-between align-items-center d-md-none user-profile-show"
                      to="#"
                    >
                      View Profile <i className="bx bx-user text-muted"></i>
                    </DropdownItem>
                    <DropdownItem
                      className="d-flex justify-content-between align-items-center d-md-none"
                      to="#"
                      onClick={onOpenAudio}
                    >
                      Audio <i className="bx bxs-phone-call text-muted"></i>
                    </DropdownItem>
                    <DropdownItem
                      className="d-flex justify-content-between align-items-center d-md-none"
                      to="#"
                      onClick={onOpenVideo}
                    >
                      Video <i className="bx bx-video text-muted"></i>
                    </DropdownItem>
                    <DropdownItem
                      className="d-flex justify-content-between align-items-center"
                      to="#"
                    >
                      Archive <i className="bx bx-archive text-muted"></i>
                    </DropdownItem>
                    <DropdownItem
                      className="d-flex justify-content-between align-items-center"
                      to="#"
                    >
                      Muted <i className="bx bx-microphone-off text-muted"></i>
                    </DropdownItem>
                    <DropdownItem
                      className="d-flex justify-content-between align-items-center"
                      to="#"
                    >
                      Delete <i className="bx bx-trash text-muted"></i>
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown> */}
              </div>
            </div>
          </div>
          <div className="mt-auto p-3">
            <h5
              // onClick={onModalFindCustomer}
              className={classnames("user-name mb-1 text-truncate d-flex justify-content-between align-items-center", { "groupchat-no-company": !chatUserDetails.companyId })}
            >
              {!editingName && (<span onClick={onModalFindCustomer} className="hand">
                {(canMapGroup && chatUserDetails.customerCode) && (<>{chatUserDetails.customerCode}:</>)}
                {fullName}
              </span>)}

              {editingName && (
                <TextBox
                  type="text" className="form-control" style={{ padding: "2px" }}
                  onChange={(e) => setNameEdit(e.target.value)}
                  onEnter13={onSaveNameClick}
                  value={nameEdit}
                />
                // <input type="text" className="form-control" style={{padding:"2px"}} value={fullName}></input>
              )}
              <span id="spnChatId" style={{ fontSize: ".8em", "display": "none" }} >{chatUserDetails.id}</span>

              {canMapGroup && (
                <>
                  {!editingName && (<i className="bx bxs-edit-alt text-black" onClick={onEditNameClick} style={{ cursor: "pointer", fontSize: "1.3rem" }}></i>)}
                  {editingName && (
                    <>
                      <i className="bx bxs-save text-black" onClick={onSaveNameClick} style={{ cursor: "pointer", fontSize: "1.3rem" }}></i>
                      <i className="bx bx-reset text-black" onClick={onCancelNameClick} style={{ cursor: "pointer", fontSize: "1.3rem" }}></i>
                    </>
                  )}
                </>
              )}
            </h5>
            {/* <span>D Connect COmpany</span> */}
            {chatUserDetails.status && (
              <p className="font-size-14 text-truncate mb-0">
                <i
                  className={classnames(
                    "bx",
                    "bxs-circle",
                    "font-size-10",
                    "me-1",
                    "ms-0",
                    {
                      "text-success":
                        chatUserDetails.status === STATUS_TYPES.ACTIVE,
                    },
                    {
                      "text-warning":
                        chatUserDetails.status === STATUS_TYPES.AWAY,
                    },
                    {
                      "text-danger":
                        chatUserDetails.status === STATUS_TYPES.DO_NOT_DISTURB,
                    }
                  )}
                ></i>{" "}
                {chatUserDetails.status}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileUser;
